/* Created by Interactive 63 - https://interactive63.com */
/**
 * Pure helpers for the editor's loop emulation: which animations belong to tracks that play once,
 * so they can be held at their end pose from the second pass of a looping preview onwards.
 */
import { kebab } from '../core/compiler/values';
import type { Project } from '../core/model/types';

/** The CSS animation names of tracks that play only during the first scene iteration. */
export function onceAnimationNames(project: Project): Set<string> {
  const scene = project.export.sceneName || 'scene';
  return new Set(
    project.tracks
      .filter(
        (t) =>
          t.enabled &&
          t.restartWithScene === false &&
          t.property !== 'morph' &&
          t.keyframes.length > 1,
      )
      .map((t) => `st-${scene}-${t.elementId}-${kebab(t.property)}`),
  );
}

/** Whether an animation should be held at its end pose on the given pass (0 is the first). */
export function holdsAfterFirstPass(
  animationName: string,
  onceNames: ReadonlySet<string>,
  pass: number,
): boolean {
  return pass > 0 && onceNames.has(animationName);
}
